export default "__VITE_ASSET__3MMeKikF__"